import { useMutation } from '@tanstack/react-query'
import { MessageService } from '../services/MessageService'

interface UseMutationBuildPromotionFlexOptions {
	onSuccess?: (
		data: { flexJson: any; lineTransactionType: string } | null,
	) => void
	onError?: (error: Error) => void
}

export default function useMutationBuildPromotionFlex({
	onSuccess,
	onError,
}: UseMutationBuildPromotionFlexOptions = {}) {
	return useMutation({
		mutationFn: (dto: {
			promotionIds: string[]
			enableInstantClaim?: boolean
		}) => MessageService.buildPromotionFlex(dto),
		onSuccess,
		onError,
	})
}
